<template>
  <div>
    <div id="close-setting">
      <b-icon @click.native="$router.push('/settings')" class="hoverable" icon="close-circle" />
    </div>
    <h1 class="title is-4">Thema</h1>
    <hr />
    <div class="block">We raden donkere modus aan, voor de oogkes.</div>
    <b-switch class="mr-5" :value="!darkMode" @input="changeDarkmode()" passive-type="is-default" type="is-warning" size="is-small" :left-label="true">
      <b-icon v-if="darkMode" size="is-small" icon="moon-waxing-crescent" />
      <b-icon v-else size="is-small" icon="white-balance-sunny" />
    </b-switch>
    <hr />
  </div>
</template>
<script>
import { TOGGLE_DARKMODE } from "@/store/App/mutation.type" 

export default {
  data() {
    return {
    }
  },
  methods: {
    changeDarkmode() {
      this.$store.commit(`app/${TOGGLE_DARKMODE}`)
    }
  },
  computed: {
    darkMode() {
      return this.$store.state.app.darkMode
    }
  },
}
</script>
<style lang="scss" scoped>
#close-setting {
  display: none;
  position: absolute;
  top: 10px;
  right: 10px;
}
@media only screen and (max-width: 1200px) {
  #close-setting {
    display: block;
  }
}
</style>
